import React, { Component } from 'react';

export default class MetricsCompareItem extends Component {

    constructor(props) {
        super(props); // props: compareFunction, compareMode, icon, text

        this.defaultProps = {}

        this.state = {

        }
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }


    render() {

        let hasSubtext = this.props.subtext != undefined;

        return (
            <div onClick={this.props.compareFunction.bind(null, this.props.compareMode)} style={this.props.style} className={"metrics-sort-item-outer" + (hasSubtext ? " sub-mode" : "")}>
                <div className={"metrics-sort-item-icon material-icons" + (zzDataCache.settings.compareMode === this.props.compareMode ? ' color-emerald' : '')}>{this.props.icon}</div>
                <div className="metrics-sort-item-text long">{this.props.text}</div>
                {
                    !hasSubtext ? null :
                        (
                            <div className={"metrics-sort-item-subtext"}>{this.props.subtext}</div>
                        )
                }
            </div>
        );
    }
}